import { client } from '../../config/apollo/client';
import { concatPath } from '../../utils/links/concatPath';
import { loginKey, tabsKey } from '../../constants/routeKeys';
import { publicKey } from '../../constants/routeKeys';
import { queryCloseActiveWpoVideoRequest } from '../../state/queries/InstantHelp';
import { remove } from '../../utils/storage';
import { router } from 'expo-router';
import { useStores } from '../useStores';


export const useLogout = (cb?: () => void) => {
  const rootStore = useStores();




  const logout = async () => {
    rootStore?.onboarding.set(false);

    // BEFORE the token goes. An open WPO video request has to be closed while the
    // session that owns it still exists: once the token is removed, authLink sends an
    // empty Authorization header, updateWPORequest drops out of the filtered schema,
    // and the request stays open -- which is what later makes WPO refuse a new call
    // with "a call is already going on". Awaited, but it cannot block logout: it has
    // its own timeout and swallows every failure.
    await queryCloseActiveWpoVideoRequest();

    remove('token');
    await rootStore?.clear();

    // Was `await client.clearStore()`, which throws Apollo's
    // "Store reset while query was in flight" at every watchQuery still subscribed --
    // i.e. every query on the screen you are logging out of. Those rejections come
    // from the aborted observers, NOT from clearStore()'s own promise, so wrapping the
    // await in try/catch does not catch them: they surface as
    // "Uncaught (in promise) Invariant Violation" and, on web, killed the rest of
    // logout so the navigation below never ran.
    //
    // stop() tears the queries down without erroring them; cache.reset() then does the
    // actual purge, which is all this needed -- clearStore() adds nothing else here.
    try {
      client.stop();
      await client.cache.reset();
    } catch (error) {
      console.log('logout: cache reset failed', error);
    }

    try {
      // (Tabs) is required: the login route is app/(public)/(Tabs)/login.tsx, so
      // without it this resolved to /(public)/login -- a route that does not exist.
      // Same shape AuthenticatedApp already uses for its logout redirect.
      router.navigate({
        pathname: concatPath([publicKey, tabsKey, loginKey], -1) as string,
      });
    } catch(error) {
      console.log('error',error);
    }
    if(cb) {
      cb();
    }

  };
  return logout;
};